import React from 'react';
import { motion } from 'framer-motion';

const LoadingSpinner = ({ 
  size = 'medium', 
  color = 'primary', 
  text = null,
  className = '',
  ...props 
}) => {
  const sizeClasses = {
    small: 'loading-spinner--small',
    medium: '',
    large: 'loading-spinner--large'
  };

  const colorStyles = {
    primary: { borderTopColor: 'var(--primary-color)' },
    white: { borderTopColor: 'var(--white)' },
    gray: { borderTopColor: 'var(--gray-600)' }
  };

  return (
    <motion.div 
      className={`loading-container ${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      {...props}
    >
      <div 
        className={`loading-spinner ${sizeClasses[size]}`}
        style={colorStyles[color]}
        role="status"
        aria-label={text || "Loading"}
      >
        <span className="sr-only">{text || "Loading..."}</span>
      </div>
      {text && (
        <motion.p 
          className="loading-text"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.3 }}
        >
          {text}
        </motion.p>
      )}
    </motion.div>
  );
};

// Skeleton loader for content placeholders
export const SkeletonLoader = ({ 
  width = '100%', 
  height = '20px', 
  className = '',
  count = 1 
}) => {
  return (
    <div className={`skeleton-container ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <motion.div
          key={index}
          className="skeleton-item"
          style={{ width, height }}
          initial={{ opacity: 0.6 }}
          animate={{ opacity: [0.6, 1, 0.6] }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut",
            delay: index * 0.1
          }}
        />
      ))}
    </div>
  );
};

// Page loading component
export const PageLoader = ({ message = "Loading page..." }) => {
  return (
    <motion.div 
      className="page-loader"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="page-loader-content">
        <LoadingSpinner size="large" />
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {message}
        </motion.p>
      </div>
    </motion.div>
  );
};

export default LoadingSpinner;